"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Timer = function (props) {
    var initialSeconds = props.initialSeconds;
    var _a = React.useState(initialSeconds), seconds = _a[0], setSeconds = _a[1];
    React.useEffect(function () {
        var isMounted = true;
        if (seconds > 0) {
            setTimeout(function () {
                if (isMounted)
                    setSeconds(seconds - 1);
            }, 1000);
        }
        else {
            if (isMounted) {
                props.onFinishCount();
            }
        }
        return function () { isMounted = false; };
    }, [seconds]);
    return (React.createElement("div", { className: "App" },
        React.createElement("div", null,
            ("" + Math.floor(seconds / 60)).padStart(2, '0'),
            ":",
            ("" + seconds % 60).padStart(2, '0'))));
};
exports.default = Timer;
//# sourceMappingURL=timer.js.map